module.exports = __webpack_public_path__ + "img/FactsheetImage_2020.b94a01b9.jpg";